module.exports = __webpack_public_path__ + "static/media/open-lock.def2bd39.svg";